<template>
    <div>
        <skupovi-navigation
                :id="skup_id"
                :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Dodatni sadržaj</h5>
            </div>
            <div class="ibox-content">
                <skup-dodatni-sadrzaj-forma
                        :disabled="false"
                        :id="null"
                        :modal="false"
                        :action="'create'"
                >
                </skup-dodatni-sadrzaj-forma>
            </div>
        </div>
    </div>
</template>

<script>
import SkupDodatniSadrzajForma from "@/views/pages/Skupovi/SkupoviDodatniSadrzaji/SkupDodatniSadrzajForma";
import SkupoviNavigation from "@/views/pages/Skupovi/SkupoviNavigation";
export default {
name: "SkupDodatniSadrzajCreate",
    components: {
        SkupDodatniSadrzajForma,
        SkupoviNavigation
    },
    data(){
        return {
            breadcrumbs: [],
            skup_id: this.$route.params.skup_id,
            skup: {}
        }
    },
    methods:{
        setBreadcrumbs() {
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/dodatni-sadrzaji',
                    name: 'Dodatni sadržaji'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/dodatni-sadrzaji/create',
                    name: 'Novi dodatni sadržaj'
                }
            ]
        },
    },
    mounted() {
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>